import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { addListToDropdown, createDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import Model from '@ckeditor/ckeditor5-ui/src/model';

import { CkeditorConstants } from "../../src/utils";
import SubTemplateIcon from './icons/file-plus-outline.svg';
import SubTemplatesCommand from './subtemplatescommand';
import { SubtemplateShared as Shared } from './subtemplates-shared';

const {
    localStorageItem: { SUBTEMPLATE_OBJECT, EXISTING_SUBTEMPLATES },
    htmlElement: { DIV },
    helperAttributes: { SUBTEMPLATES_ALLOW, SUBTEMPLATES_RULES, CONTENTEDITABLE } } = CkeditorConstants;

export default class SubTemplatesUI extends Plugin {
    init() {
        const editor = this.editor;
        let subtemplatesNames = [];
        let subtemplatesNamesAllowed = [];
        let listofTemplateObject = [];
        let selection;
        this.editor.commands.add('subTemplates', new SubTemplatesCommand(this.editor));
        editor.ui.componentFactory.add('subTemplates', locale => {
            let dropdownView = createDropdown(locale);

            // Populate the list in the dropdown with items.
            addListToDropdown(dropdownView, getDropdownItemsDefinitions(subtemplatesNames));

            dropdownView.buttonView.set({
                icon: SubTemplateIcon,
                tooltip: 'Insert Subtemplate',
                class: 'subTemplateIcon'
            });

            // Disable the placeholder button when the command is disabled.
            const command = editor.commands.get('subTemplates');
            dropdownView.bind('isEnabled').to(command);

            dropdownView.buttonView.on('change', () => {
                const dropdownPanel = dropdownView.element.querySelector('.ck-dropdown__panel');
                if (dropdownPanel) {
                    while (dropdownPanel.firstChild && dropdownPanel.children.length > 1) {
                        dropdownPanel.removeChild(dropdownPanel.firstChild);
                    }
                }
            });

            // Execute the command when the dropdown item is clicked (executed).
            this.listenTo(dropdownView, 'execute', evt => {
                if (evt.source.element.className.indexOf('ck-disabled') <= -1) {
                    const foundItems = [];
                    const children = selection instanceof HTMLElement ? selection.children : selection._children;
                    for (const item of children) {
                        if (item.getAttribute('data-subtemplate-name')) {
                            foundItems.push(item.getAttribute('data-subtemplate-name'));
                        }
                    }

                    let selectedSubtemplateItem;
                    if (subtemplatesNames) {
                        selectedSubtemplateItem = subtemplatesNames.filter(x => x.name == evt.source.commandParam);
                    }
                    let numOfSubtemplateItem = 0;
                    numOfSubtemplateItem = foundItems.filter(x => x == evt.source.commandParam).length;
                    if (selectedSubtemplateItem[0]?.totalAllowedtemplates !== 'n') {
                        let commaIndex = selectedSubtemplateItem[0].matches.indexOf(',');
                        let hypenIndex = selectedSubtemplateItem[0].matches.indexOf('-');
                        for (let element of dropdownView?.element?.lastElementChild?.getElementsByTagName('button')) {
                            if (element.lastChild.innerText === selectedSubtemplateItem[0].name || element.lastChild.innerText === selectedSubtemplateItem[0].title) {
                                if (numOfSubtemplateItem > 0 && selectedSubtemplateItem[0].totalAllowedtemplates.indexOf(',') >= -1) {
                                    if (commaIndex > -1) {
                                        selectedSubtemplateItem[0].totalAllowedtemplates = selectedSubtemplateItem[0].matches.substring(commaIndex + 1, selectedSubtemplateItem[0].matches.length);
                                        makeBtnDisable(element);
                                    }
                                }
                                if (numOfSubtemplateItem > 0 && selectedSubtemplateItem[0].totalAllowedtemplates.indexOf('-') >= -1) {
                                    if (hypenIndex > -1) {
                                        selectedSubtemplateItem[0].totalAllowedtemplates = '[0-' + selectedSubtemplateItem[0].matches.substring(hypenIndex + 1, selectedSubtemplateItem[0].matches.length) + ']';
                                    }
                                }
                                if (selectedSubtemplateItem[0].totalAllowedtemplates.indexOf('-') > -1) {
                                    if (numOfSubtemplateItem + 1 >= selectedSubtemplateItem[0].subTemplateInDom) {
                                        makeBtnDisable(element);
                                    }
                                }
                                else if (selectedSubtemplateItem[0].totalAllowedtemplates === selectedSubtemplateItem[0].subTemplateInDom) {
                                    makeBtnDisable(element);
                                }
                                else {
                                    if (numOfSubtemplateItem + selectedSubtemplateItem[0].totalAllowedtemplates === selectedSubtemplateItem[0].subTemplateInDom) {
                                        makeBtnDisable(element);
                                    }
                                    else if (numOfSubtemplateItem === 0) {
                                        if (hypenIndex > -1) {
                                            selectedSubtemplateItem[0].totalAllowedtemplates = selectedSubtemplateItem[0].matches.substring(0, hypenIndex);
                                        }
                                        if (commaIndex > -1) {
                                            selectedSubtemplateItem[0].totalAllowedtemplates = selectedSubtemplateItem[0].matches.substring(0, commaIndex);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    editor.fire('insertSubTemplate', selectedSubtemplateItem);
                }
            });

            //Update the list in dropdown when subtemplates allowed in section clicked.
            this.listenTo(editor.editing.view.document, 'keyup', (evt, data) => {
                const subTemplateList = JSON.parse(localStorage.getItem('subTemplateList'));
                dropdownView.isOpen = false;
                listofTemplateObject = updateListOfDropdown(data, dropdownView, selection, subtemplatesNames, subtemplatesNamesAllowed, this.editor, 'keyup');
                dropdownView = listofTemplateObject.dropdownView;
                selection = listofTemplateObject.sel;
                subtemplatesNames = listofTemplateObject.subtemplatesNames;
                subtemplatesNamesAllowed = listofTemplateObject.subtemplatesNamesAllowed;
                const existingSubtemplates = subtemplatesNames?.filter((t) => subTemplateList ? subTemplateList.some((st) => st.name.trim() === t.name.trim()) : '');
                localStorage.setItem(EXISTING_SUBTEMPLATES, JSON.stringify(existingSubtemplates));
            });

            this.listenTo(editor.editing.view.document, 'click', (evt, data) => {
                const subTemplateList = JSON.parse(localStorage.getItem('subTemplateList'));
                listofTemplateObject = updateListOfDropdown(data, dropdownView, selection, subtemplatesNames, subtemplatesNamesAllowed, this.editor, 'click');
                localStorage.setItem(SUBTEMPLATE_OBJECT, JSON.stringify(listofTemplateObject.subtemplatesNames));
                dropdownView = listofTemplateObject.dropdownView;
                selection = listofTemplateObject.sel;
                subtemplatesNames = listofTemplateObject.subtemplatesNames;
                subtemplatesNamesAllowed = listofTemplateObject.subtemplatesNamesAllowed;
                const existingSubtemplates = subtemplatesNames?.filter((t) => subTemplateList ? subTemplateList.some((st) => st.name.trim() === t.name.trim()) : '');
                localStorage.setItem(EXISTING_SUBTEMPLATES, JSON.stringify(existingSubtemplates));
            });

            return dropdownView;
        });
    }
}

function updateListOfDropdown(data, dropdownView, selection, subtemplatesNames, subtemplatesNamesAllowed, editor, clickOrkeyUp) {
    subtemplatesNames = [];
    subtemplatesNamesAllowed = [];

    const domTarget = data?.domTarget;
    const editorTarget = clickOrkeyUp === 'click' ? data?.domTarget.closest(`[${SUBTEMPLATES_ALLOW}]`): Shared.getDocumentSelectedElement(editor.model.document) ;

    selection = /^false$/i.test(domTarget.getAttribute(CONTENTEDITABLE))
        ? Shared.getSubtemplateAttrDomElement(Shared.getDomContainerElement(domTarget))
        : editorTarget && Shared.getSubtemplateAttrEditorElement(Shared.getEditorContainerElement(editorTarget));

    if (selection) {
        const hasSubtemplatesAllow = selection.hasAttribute?.(SUBTEMPLATES_ALLOW);
        const hasSubtemplatesRules = selection.hasAttribute?.(SUBTEMPLATES_RULES);
        if (hasSubtemplatesAllow && hasSubtemplatesRules) {
            dropdownView.element.lastElementChild.innerHTML = '';
            subtemplatesNames = updateArray(selection.getAttribute(SUBTEMPLATES_ALLOW));
            subtemplatesNamesAllowed = updateArray(selection.getAttribute(SUBTEMPLATES_RULES));

            const foundItems = [];
            const children = selection instanceof HTMLElement ? selection.children : selection._children;
            for (const item of children) {
                if (item.getAttribute('data-subtemplate-name')) {
                    foundItems.push(item.getAttribute('data-subtemplate-name'));
                }
            }
            subtemplatesNames = dropDownArray(subtemplatesNames, subtemplatesNamesAllowed, foundItems, 'withRules');
            addListToDropdown(dropdownView, getDropdownItemsDefinitions(subtemplatesNames));
        } else if (hasSubtemplatesAllow && !hasSubtemplatesRules) {
            dropdownView.element.lastElementChild.innerHTML = '';
            subtemplatesNames = updateArray(selection.getAttribute(SUBTEMPLATES_ALLOW));
            const foundItems = [];
            subtemplatesNames = dropDownArray(subtemplatesNames, subtemplatesNamesAllowed, foundItems, 'withoutRules');
            addListToDropdown(dropdownView, getDropdownItemsDefinitions(subtemplatesNames));
        }
    }

    return { 'sel': selection, 'dropdownView': dropdownView, 'subtemplatesNames': subtemplatesNames, 'subtemplatesNamesAllowed': subtemplatesNamesAllowed };
}

function makeBtnDisable(element) {
    let attrList = element.getAttribute('class');
    attrList = attrList + ' ck-disabled';
    element.setAttribute('class', attrList);
}

function dropDownArray(subtemplatesNames, subtemplatesNamesAllowed, foundItems, strToIdentifyRules) {
    let subtemplatesArray = [];
    if (strToIdentifyRules === 'withRules' && (subtemplatesNamesAllowed.length === subtemplatesNames.length)) {
        for (let templateName of subtemplatesNames) {
            let allowRuleArray = subtemplatesNamesAllowed;
            templateName = templateName.trim();
            allowRuleArray = allowRuleArray.filter(e => {
                const regexBrackets = /(^.*)\[.*\]$/i;
                const splitNames = e.split(regexBrackets);
                const eRuleWithoutBrackets = (splitNames.length === 1) ? splitNames[0] : splitNames[1];
                return eRuleWithoutBrackets.indexOf(templateName) > -1
            });
            let countAllowedFortheTemplate = 0;
            if (allowRuleArray.length === 1) {
                subtemplatesArray.push(ruletoLimitSubtemplate(countAllowedFortheTemplate, templateName, foundItems, allowRuleArray));
            }
        }
    } else if (strToIdentifyRules === 'withoutRules' && (subtemplatesNamesAllowed.length === 0)) {
        subtemplatesArray = noRuletoLimitSubtemplate(subtemplatesNames);
    } else {
        for (let templateName of subtemplatesNames) {
            let allowRuleArray = subtemplatesNamesAllowed;
            templateName = templateName.trim();
            allowRuleArray = allowRuleArray.filter(e => {
                const regexBrackets = /(^.*)\[.*\]$/i;
                const splitNames = e.split(regexBrackets);
                const eRuleWithoutBrackets = (splitNames.length === 1) ? splitNames[0] : splitNames[1];
                return eRuleWithoutBrackets.indexOf(templateName) > -1
            });
            let countAllowedFortheTemplate = 0;
            if (allowRuleArray.length === 1) {
                subtemplatesArray.push(ruletoLimitSubtemplate(countAllowedFortheTemplate, templateName, foundItems, allowRuleArray));
            } else {
                let obj = {};
                obj = { name: templateName, isEnabled: true, totalAllowedtemplates: 'n', subTemplateInDom: 'n' };
                subtemplatesArray.push(obj)
            }
        }
    }
    return subtemplatesArray;
}

function noRuletoLimitSubtemplate(subtemplatesNames) {
    let subtemplatesArray = [];
    for (let templateName of subtemplatesNames) {
        templateName = templateName.trim();
        let obj = {};
        obj = {
            name: templateName,
            isEnabled: true,
            totalAllowedtemplates: 'n',
            subTemplateInDom: 'n'
        };
        subtemplatesArray.push(obj)
    }
    return subtemplatesArray;
}

function ruletoLimitSubtemplate(countAllowedFortheTemplate, templateName, foundItems, allowRuleArray) {
    let subTemplateTitle = getSubTemplateTitle(templateName);
    let matches = allowRuleArray[0].match(/\[(.*?)\]/);
    let matchLeft, matchRight, total;

    if (matches[1]?.length >= 3) {
        if (matches[1].split('-').length >= 2) {
            matchLeft = matches[1].split('-')[0];
            matchRight = matches[1].split('-')[1];
        }
        if (matches[1].split(',').length >= 2) {
            matchLeft = matches[1].split(',')[0];
            matchRight = matches[1].split(',')[1];
        }
        total = parseInt(matchLeft) + parseInt(matchRight);
    }

    let hypenIndex = matches[1].indexOf('-');
    let commaIndex = matches[1].indexOf(',');
    let matchesLength = matches[1].length;

    if (hypenIndex > -1) {
        if (matches[1].substring(0, hypenIndex) > 0) {
            countAllowedFortheTemplate = total;
        } else {
            countAllowedFortheTemplate = matches[1].substring(hypenIndex + 1, matchesLength)
        }
    } else if (commaIndex > -1) {
        if (matches[1].substring(0, commaIndex) > 0) {
            countAllowedFortheTemplate = total;
        } else {
            countAllowedFortheTemplate = matches[1].substring(commaIndex + 1, matchesLength)
        }
    }
    else {
        countAllowedFortheTemplate = matches[1];
    }

    let numOfSubtemplateItem = 0;
    numOfSubtemplateItem = foundItems.filter(x => x == templateName).length;
    let obj = {};
    if (matchLeft > 0) {
        if (numOfSubtemplateItem >= total) {
            obj = {
                name: templateName,
                isEnabled: false,
                totalAllowedtemplates: matches[1],
                subTemplateInDom: countAllowedFortheTemplate,
                title: subTemplateTitle,
                matches: matches[1]
            };
        } else {
            if (hypenIndex > -1) {
                if (matchLeft > numOfSubtemplateItem) {
                    obj = {
                        name: templateName,
                        isEnabled: true,
                        totalAllowedtemplates: matches[1].substring(0, hypenIndex),
                        subTemplateInDom: countAllowedFortheTemplate,
                        title: subTemplateTitle,
                        matches: matches[1]
                    };
                }
                else {
                    obj = {
                        name: templateName,
                        isEnabled: true,
                        totalAllowedtemplates: '[0-' + matches[1].substring(hypenIndex + 1, matchesLength) + ']',
                        subTemplateInDom: countAllowedFortheTemplate,
                        title: subTemplateTitle,
                        matches: matches[1]
                    };
                }
            } else if (commaIndex > -1) {
                if (matchLeft > numOfSubtemplateItem) {
                    obj = {
                        name: templateName,
                        isEnabled: true,
                        totalAllowedtemplates: matches[1].substring(0, commaIndex),
                        subTemplateInDom: countAllowedFortheTemplate,
                        title: subTemplateTitle,
                        matches: matches[1]
                    };
                } else {
                    obj = {
                        name: templateName,
                        isEnabled: true,
                        totalAllowedtemplates: matches[1].substring(commaIndex + 1, matchesLength),
                        subTemplateInDom: matches[1].substring(commaIndex + 1, matchesLength),
                        title: subTemplateTitle,
                        matches: matches[1]
                    };
                }
            }
        }
    } else {
        if (numOfSubtemplateItem >= countAllowedFortheTemplate) {
            obj = {
                name: templateName,
                isEnabled: false,
                totalAllowedtemplates: matches[1],
                subTemplateInDom: countAllowedFortheTemplate,
                title: subTemplateTitle,
                matches: matches[1]
            };
        } else {
            obj = {
                name: templateName,
                isEnabled: true,
                totalAllowedtemplates: matches[1],
                subTemplateInDom: countAllowedFortheTemplate,
                title: subTemplateTitle,
                matches: matches[1]
            };
        }
    }
    return obj;
}

function updateArray(subTemplateNamesString) {
    if (subTemplateNamesString) {
        const regexByComma = /(?![^)(]*\([^)(]*?\)\)),(?![^\[]*\])/;
        return subTemplateNamesString.split(regexByComma).map(subTemplateName => {
            const subTemplateNameInt = parseInt(subTemplateName);
            return subTemplateNameInt ? subTemplateNameInt : subTemplateName
        })
    } else {
        return [];
    }
}

function getDropdownItemsDefinitions(subtemplatesNames) {
    const itemDefinitions = new Collection();
    // Alphabetic sort for subtemplate.
    subtemplatesNames.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    for (const subtemplatesName of subtemplatesNames) {
        const subTemplates = getSameSubTemplatesFromStorage(subtemplatesName.name)
        if (!subTemplates.length) continue
        const definition = {
            type: 'button',
            model: new Model({
                commandParam: subtemplatesName.name,
                label: subTemplates[0].title || subtemplatesName.name,
                withText: true,
                tooltip: true,
                class: subtemplatesName.isEnabled ? 'subtemplate-button' : 'subtemplate-button ck-disabled',
            })
        };
        // Add the item definition to the collection.
        itemDefinitions.add(definition);
    }
    return itemDefinitions;
}

function getSubTemplateTitle(subTemplateName) {
    let subTemplatesWithSameName = getSameSubTemplatesFromStorage(subTemplateName);
    if (subTemplatesWithSameName.length) {
        return subTemplatesWithSameName[0].title ? subTemplatesWithSameName[0].title : subTemplateName;
    }
    return null;
}

function getSameSubTemplatesFromStorage(subTemplateName) {
    const subTemplates = JSON.parse(localStorage.getItem('subTemplateList'));
    return subTemplates?.filter((subTemplate) => subTemplate.name === subTemplateName) ?? [];
}
